import React, { Component } from 'react';
import MaterialTable from 'material-table';
import{ SERVER_PATH, AXIOS_CONFIG} from '../common/redux/constantes';
import SelectDeliverable from './SelectDeliverable';
// import moment from 'moment';
import SelectControlAccount from './SelectControlAccount';
import DownloadCsv from "../common/DownloadCsv"
export default class MaterialCost extends Component {
  static propTypes = {

  };


  state ={
    costs:[],
    deliverableSelected:-1, 
    tableData:[]
  }

  constructor(props) {
    super(props);
    this.tableRef = React.createRef();
    //bindings
    this.changeDeliverableSelected = this.changeDeliverableSelected.bind(this);
    this.setDownloadInfo= this.setDownloadInfo.bind(this);
  }
  setDownloadInfo=(info)=>{
    let value={ data:JSON.parse(JSON.stringify(info)), 
             headers:[
             {label:"Type", key:"type"},
             {label:"Total Cost", key:"total_cost"}
             ],
             tableName:"OtherCosts", 
             lookupTable:['Labor','Equipment','Material','Other', 'SubContract','Total'],
             type:5
           }
     this.setState({
       tableData:value
     })
   }

  changeDeliverableSelected(deliverable_id)
  {
    this.setState({deliverableSelected:deliverable_id});
    this.refreshTable();
  }  


  refreshTable=()=>
  {
    this.tableRef.current && this.tableRef.current.onQueryChange()
  }


  render() {
    let actionButtons = [
      {
        icon: 'refresh',
        tooltip: 'Refresh Data',
        isFreeAction: true,
        onClick: () => this.tableRef.current && this.tableRef.current.onQueryChange(),
      },
      {
        icon: 'save',
        tooltip: 'Download Data',
        isFreeAction: true,
        onClick: () => 
        {
          this.childref.downloadData()
        }
      }
    ];
    return (
      <div className="summary-generic-cost">
          {this.props.project> 0?
            <SelectControlAccount  
              project={this.props.project}
              changeDeliverable={this.changeDeliverableSelected}/>
            :
            <SelectDeliverable  
              ca_name={this.props.ca_name} 
              project={this.props.project} 
              ca={this.props.ca} 
              changeDeliverable={this.changeDeliverableSelected}/>
          }
          <MaterialTable
          tableRef={this.tableRef}
          onRowClick={((evt, selectedRow) => this.setState({ selectedRow }))}
          options={{
            actionsColumnIndex:7,
            paging:false,
            search:false,
            sorting:false,
            maxBodyHeight:"600px",
            headerStyle: {
              backgroundColor: '#FFF',
              color: '#000',
              fontSize:'1.05em'
            },
            rowStyle: rowData => ({
              backgroundColor:  rowData.result ===1? '#f0f1f3' :(rowData.cost>0) ? '#eaeff7' : '#ffffff'
            })
          }}
          title="Cost of Required Resources"

          columns={[
            { 
              title: 'Resource', 
              field: 'description',
              cellStyle: {
                borderRight: "1px solid #d4d4d4"
              }
            },
            { 
              title: 'Work Package', 
              field: 'w_name',
              cellStyle: {
                borderRight: "1px solid #d4d4d4"
              }
            },
            { 
              title: 'Unit', 
              field: 'unit_name',
              cellStyle: {
                borderRight: "1px solid #d4d4d4"
              }
            },
            { 
              title: 'Quantity', 
              field: 'quantity',
              cellStyle: {
                borderRight: "1px solid #d4d4d4"
              }
            },
            { 
              title: 'Price', 
              field: 'price',
              cellStyle: {
                borderRight: "1px solid #d4d4d4"
              }
            },
            { 
              title: 'Start Date', 
              field: 'start_date',
              cellStyle: {
                borderRight: "1px solid #d4d4d4"
              }
            },
            { 
              title: 'End Date', 
              field: 'finish_date',
              cellStyle: {
                borderRight: "1px solid #d4d4d4"
              }
            },
            { 
              title: 'Number Of Days', 
              field: 'number_days',
              cellStyle: {
                borderRight: "1px solid #d4d4d4"
              }
            },
            { 
              title: 'Daily Cost', 
              field: 'daily_cost',
              cellStyle: {
                borderRight: "1px solid #d4d4d4"
              }
            },
            { 
              title: 'Total Cost', 
              field: 'total_cost',
              cellStyle: {
                borderRight: "1px solid #d4d4d4"
              }
            },
          ]}
        parentChildData={(row, rows) => {
          if(row.cost>0)
          {
            return rows.find(a=> a.cost_catalog === row.cost_catalog);
          }
        }}
         data={query =>
          new Promise((resolve, reject) => {
            let url = SERVER_PATH + '/costs/getByControlAccount/'+ this.props.ca +'/' + this.props.type + '/' + this.state.deliverableSelected;
            if(this.props.project > 0)
            {
              url = SERVER_PATH + '/costs/getByProject/'+ this.props.project +'/' + this.props.type + '/' + this.state.deliverableSelected;
            }
            fetch(url,AXIOS_CONFIG())
              .then(response => response.json())
              .then(result => {
                let formatter = null;
                if (typeof Intl === 'object' && typeof Intl.NumberFormat === 'function') 
                  {
                    formatter = new Intl.NumberFormat('gt-GT', {
                      minimumFractionDigits: 2,
                    });
                  }
                result.costs = result.costs.map(o => {
                  if(o.start_date && o.finish_date)
                  {
                    // o.start_date = moment(o.start_date).format('YYYY-MM-DD')
                    // o.finish_date = moment(o.finish_date).format('YYYY-MM-DD')
                  }
                  // o.tableData = {isTreeExpanded:true}
                  
                  if (typeof Intl === 'object' && typeof Intl.NumberFormat === 'function') 
                  {
                    o.total_cost = formatter.format(o.total_cost);
                    if(o.daily_cost)
                      o.daily_cost = formatter.format(o.daily_cost);
                    if(o.price)
                      o.price = formatter.format(o.price);
                  }
                  return o;
                });
                this.setDownloadInfo(result.costs)
                resolve({
                  data: result.costs,
                  page: 0,
                  totalCount: result.costs.length,
                })
              })
              .catch(err => {resolve({data:[], page: 0, totalCount:0})})
          })
        }
          actions={actionButtons}
        />
        <DownloadCsv 
            style={{display:"none !important"}} 
            visible={true}
            innerRef={node => this.childref = node}
            tableData={this.state.tableData}
            ocultar={true}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/summary/OtherCost.js